import {Component, OnInit, ViewChild} from '@angular/core';
import {trigger} from '@angular/animations';
import {smoothEnterLeaveAnimation} from '../../../shared/animations/custom-animations';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ForgotPasswordService} from '../../services/forgot-password.service';
import {SendConfirmationCodeByEmailComponent} from './send-confirmation-code-by-email/send-confirmation-code-by-email.component';
import {SendConfirmationCodeByPhoneComponent} from './send-confirmation-code-by-phone/send-confirmation-code-by-phone.component';
import {DomainNameParserService} from '../../../shared/services/domain-name-parser.service';
import {PHONE_NUMBER_LIST} from '../../../shared/constants/phone-numbers.const';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: [
    './forgot-password.component.css',
    './../../../../assets/css/floating-labels-select.css',
    './../../../../assets/css/floating-labels.css'
  ],
  animations: [
    trigger('showResetPasswordByEmailWindow', smoothEnterLeaveAnimation('200ms 150ms', '100ms')),
    trigger('showResetPasswordByPhoneWindow', smoothEnterLeaveAnimation('200ms 150ms', '100ms')),
    trigger('showGenericErrorAlert', smoothEnterLeaveAnimation('100ms', '100ms'))
  ]
})
export class ForgotPasswordComponent implements OnInit {

  confirmationCodeDeliveryMethod = null;
  getOtpOptionsButtonClicked = false;
  genericErrorAlertShown = false;
  customerServicePhone: string;

  @ViewChild(SendConfirmationCodeByEmailComponent)
  sendConfirmationCodeByEmailComponent: SendConfirmationCodeByEmailComponent;

  @ViewChild(SendConfirmationCodeByPhoneComponent)
  sendConfirmationCodeByPhoneComponent: SendConfirmationCodeByPhoneComponent;

  constructor(private forgotPasswordService: ForgotPasswordService, private domainNameParserService: DomainNameParserService) {
    this.customerServicePhone = PHONE_NUMBER_LIST[this.domainNameParserService.getState()];
  }

  ngOnInit(): void {
  }

  onOtpOptionSelected(): void {
    this.getOtpOptionsButtonClicked = true;
    this.genericErrorAlertShown = false;
  }

}
